export default "__VITE_ASSET__c7723c9e__"